import { lerPeriodoGlobal } from "../utils/periodoGlobal";

export interface FiltroPeriodoGlobal {
  dataIni?: string;
  dataFim?: string;
}

export function comPeriodoGlobal<T extends Record<string, unknown>>(
  filtro: T
): T & FiltroPeriodoGlobal {
  const periodo = lerPeriodoGlobal();
  if (!periodo) return filtro;

  return {
    ...filtro,
    dataIni: periodo.inicio,
    dataFim: periodo.fim,
  };
}
